import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import * as dataFormat from "./UsersDataFormatters";
import actions from "../../../actions/usersListActions";
import axios from "axios";
import { GET_USER, API_TIMEOUT } from "../../../utils";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Row,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
  DropdownToggle,
  Badge,
  UncontrolledTooltip,
  Input,
  Label,
} from "reactstrap";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";

import Widget from "../../Widget/Widget";

import s from "../Users.module.scss";
import { useDispatch } from "react-redux";
import { numberWithCommas } from "../../../utils/func";
import {
  GET_BANTUAN_TAHUN,
  POST_BANTUAN_TAHUN,
  DELETE_BANTUAN_TAHUN,
} from "../../../utils";
import { set } from "lodash";

const { SearchBar } = Search;

const UsersListTable = (props) => {
  const { rows, dispatch, loading, idToDelete, modalOpen } = props;
  const [rowsTable, setRowsTable] = useState([]);
  const [currentUser, setCurrentUser] = useState();
  const [rowsKu, setRowsKu] = useState([]);
  const [idHapus, setIdHapus] = useState();
  const currentYear = new Date().getFullYear();
  const listTahun = Array.from(
    { length: currentYear - 2018 + 1 },
    (_, i) => ({ tahun: 2018 + i })
  ).reverse();
  const [simpleDropdownValue2, setSimpleDropdownValue2] = useState(
    String(currentYear)
  );
  const [jumlahBantuan, setJumlahBantuan] = useState(0);
  const [jumlahPenerima, setJumlahPenerima] = useState(0);
  const [jumlahDana, setJumlahDana] = useState(0);

  const [tahun, setTahun] = useState(String(currentYear));
  const [selectedDinasFilter, setSelectedDinasFilter] = useState("All");
  const [rowsBase, setRowsBase] = useState([]);
  const [listDinas, setListDinas] = useState([]);

  const [modalDelete, setModalDelete] = useState(false);

  const dispatchKu = useDispatch();

  const changeSelectDropdownSimple2 = (e) => {
    const select = e.currentTarget.textContent.trim();
    setSimpleDropdownValue2(select);
    setTahun(select);
    cariBantuanTahun(select);
  };

  const cariBantuanTahun = (tahun) => {
    axios({
      method: "post",
      url: GET_BANTUAN_TAHUN,
      timeout: API_TIMEOUT,
      data: {
        tahun: tahun,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;
          data.map((item, index) => {
            const rawDana = parseFloat(String(item.totalDana || 0).replace(/[^\d.-]/g, "")) || 0;
            data[index].rawTotalDana = rawDana;
            data[index].totalDana = numberWithCommas(item.totalDana);
            if (item.target == "Kelompok") {
              data[index].total = (parseInt(item.jmlPenerima) || 0) * (parseInt(item.jmlPerklp) || 1);
            } else {
              data[index].total = parseInt(item.jmlPenerima) || 0;
            }
          });
          let dataFilter = [];

          if (currentUser.peran == "admin") {
            dataFilter = data.filter((item) => {
              return item.dinas == currentUser.dinas;
            });
          } else {
            dataFilter = data;
          }

          const isSuperAdmin = currentUser.peran == "super admin";
          if (isSuperAdmin) {
            setRowsBase(dataFilter);
            const uniqueDinasList = [...new Set(dataFilter.map((item) => item.dinas))].filter(Boolean).sort();
            setListDinas(uniqueDinasList);
          }

          const displayData =
            isSuperAdmin && selectedDinasFilter !== "All"
              ? dataFilter.filter((item) => item.dinas === selectedDinasFilter)
              : dataFilter;

          const totalPenerima = displayData.reduce((sum, item) => sum + (item.total || 0), 0);
          const totalDana = displayData.reduce((sum, item) => sum + (item.rawTotalDana || 0), 0);

          setJumlahBantuan(displayData.length);
          setJumlahPenerima(totalPenerima);
          setJumlahDana(totalDana);
          setRowsKu(
            displayData.map((item, index) => ({
              ...item,
              nomor: index + 1,
            }))
          );

          //setFirstTable(response.data.data);
        }
      })
      .catch((error) => {
        // ERROR
        alert(error);
      });
  };

  useEffect(() => {
    if (!currentUser) {
      let currentUser = JSON.parse(localStorage.getItem("user"));
      //untuk kepentngan development

      setCurrentUser(currentUser);
    }
  }, []);

  useEffect(() => {
    const uid = currentUser ? currentUser.uid : null;
    if (uid) cariBantuanTahun(String(currentYear));
  }, [currentUser]);

  useEffect(() => {
    if (currentUser?.peran == "super admin" && rowsBase.length > 0) {
      const displayData =
        selectedDinasFilter === "All"
          ? rowsBase
          : rowsBase.filter((item) => item.dinas === selectedDinasFilter);
      const totalPenerima = displayData.reduce((sum, item) => sum + (item.total || 0), 0);
      const totalDana = displayData.reduce((sum, item) => sum + (item.rawTotalDana || 0), 0);
      setJumlahBantuan(displayData.length);
      setJumlahPenerima(totalPenerima);
      setJumlahDana(totalDana);
      setRowsKu(
        displayData.map((item, index) => ({
          ...item,
          nomor: index + 1,
        }))
      );
    }
  }, [selectedDinasFilter, rowsBase, currentUser]);

  const hitungUmur = (dob) => {
    const startDate = new Date(dob);
    const today = new Date();

    const yearDiff = today.getFullYear() - startDate.getFullYear();
    const monthDiff = today.getMonth() - startDate.getMonth();
    const totalMonthDiff = yearDiff * 12 + monthDiff;
    return totalMonthDiff;
  };

  const handleDelete = () => {
    axios({
      method: "delete",
      url: DELETE_BANTUAN_TAHUN + idHapus,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL
          alert("Data bantuan berhasil dihapus");
          const idToDelete = idHapus;
          const filteredArray = rowsKu
            .filter((obj) => obj.id !== idToDelete)
            .map((item, index) => ({ ...item, nomor: index + 1 }));
          setRowsBase((prev) => prev.filter((obj) => obj.id !== idToDelete));
          const totalPenerima = filteredArray.reduce(
            (sum, item) => sum + (item.total || 0),
            0
          );
          const totalDana = filteredArray.reduce((sum, item) => {
            const dana = item.rawTotalDana ?? (parseFloat(String(item.totalDana || 0).replace(/[^\d.-]/g, "")) || 0);
            return sum + dana;
          }, 0);
          setRowsKu(filteredArray);
          setJumlahBantuan(filteredArray.length);
          setJumlahPenerima(totalPenerima);
          setJumlahDana(totalDana);
          setModalDelete(false);
        }
      })
      .catch((error) => {
        // ERROR
        alert(error);
      });
  };
  const openModal = (cell) => {
    const id = cell;

    setIdHapus(id);
    setModalDelete(true);
  };
  const closeModal = () => {
    setModalDelete(false);
  };
  const actionFormatter = (cell) => {
    return (
      <div className={`d-flex justify-content-between`}>
        <Button
          className={s.controlBtn}
          color="info"
          size="xs"
          onClick={() => props.dispatch(push(`/admin/bantuan/${cell}`))}
        >
          View
        </Button>
        <Button
          className={`${s.controlBtn} mx-2`}
          color="success"
          size="xs"
          onClick={() => props.dispatch(push(`/admin/bantuan/${cell}/edit`))}
        >
          Edit
        </Button>
        <Button
          className={s.controlBtn}
          color="danger"
          size="xs"
          onClick={() => {
            openModal(cell);
          }}
        >
          Delete
        </Button>
      </div>
    );
  };

  useEffect(() => {
    dispatch(actions.doFetch({}));
  }, []);

  const columns = [
    {
      dataField: "nomor",
      text: "No.",
      sort: true,
      headerStyle: { width: "60px", minWidth: "60px", textAlign: "center" },
      style: { width: "60px", minWidth: "60px" },
    },
    {
      dataField: "tahun",
      sort: true,
      text: "Tahun",
      headerStyle: { width: "80px", minWidth: "80px", textAlign: "center" },
      style: { width: "80px", minWidth: "80px" },
    },
    {
      dataField: "dinas",
      sort: true,
      text: "Dinas",
      headerStyle: { width: "140px", minWidth: "140px" },
      style: { width: "140px", minWidth: "140px" },
    },
    {
      dataField: "bantuan",
      sort: true,
      text: "Bantuan",
      headerStyle: { width: "200px", minWidth: "120px" },
      style: { width: "200px", minWidth: "120px" },
      formatter: (cell) => (
        <span style={{ wordBreak: "break-word", display: "block" }}>
          {cell}
        </span>
      ),
    },
    {
      dataField: "target",
      sort: true,
      text: "Target",
      headerStyle: { width: "100px", minWidth: "100px" },
      style: { width: "100px", minWidth: "100px" },
    },
    {
      dataField: "jenis",
      sort: true,
      text: "Jenis",
      headerStyle: { width: "110px", minWidth: "110px" },
      style: { width: "110px", minWidth: "110px" },
    },
    {
      dataField: "jmlPenerima",
      sort: true,
      text: "Total Penerima",
      headerStyle: { width: "120px", minWidth: "120px" },
      style: { width: "120px", minWidth: "120px" },
    },
    {
      dataField: "totalDana",
      sort: true,
      text: "Total Dana",
      headerStyle: { width: "130px", minWidth: "130px" },
      style: { width: "130px", minWidth: "130px" },
    },
    {
      dataField: "id",
      formatter: actionFormatter,
      text: "Actions",
      headerStyle: { width: "180px", minWidth: "180px" },
      style: { width: "180px", minWidth: "180px" },
    },
  ];

  return (
    <div className={s.jenisBantuanMinimal}>
      <Widget className="widget-p-md">
        <Row className="mb-3">
          <Col xs={12}>
            <div className={`d-flex flex-wrap align-items-center ${s.summaryChipsWrap}`}>
              <span className={s.summaryChip} id="chip-bantuan-users">
                <span className={s.summaryChipLabel}>Jumlah Bantuan</span>
                <Badge color="danger" pill className={s.summaryChipValue}>
                  {jumlahBantuan}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-bantuan-users">
                Total program bantuan pada tahun yang dipilih
              </UncontrolledTooltip>

              <span className={s.summaryChip} id="chip-penerima-users">
                <span className={s.summaryChipLabel}>Jumlah Penerima</span>
                <Badge color="primary" pill className={s.summaryChipValue}>
                  {numberWithCommas(jumlahPenerima)}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-penerima-users">
                Total penerima bantuan (Individu + Kelompok) pada tahun yang dipilih
              </UncontrolledTooltip>

              <span className={s.summaryChip} id="chip-dana-users">
                <span className={s.summaryChipLabel}>Jumlah Dana</span>
                <Badge color="success" pill className={s.summaryChipValue}>
                  Rp {numberWithCommas(jumlahDana)}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-dana-users">
                Total dana bantuan (Rp) pada tahun yang dipilih
              </UncontrolledTooltip>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            className="pr-grid-col"
            xs={12}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <div className="d-flex align-items-center flex-wrap">
              <UncontrolledButtonDropdown>
                <DropdownToggle caret color="primary" id="dropdown-tahun-users">
                  {simpleDropdownValue2}
                </DropdownToggle>
                <UncontrolledTooltip placement="top" target="dropdown-tahun-users">
                  Filter data bantuan berdasarkan tahun
                </UncontrolledTooltip>
                <DropdownMenu>
                  {listTahun &&
                    listTahun.map((item) => (
                      <DropdownItem
                        key={item.tahun}
                        onClick={changeSelectDropdownSimple2}
                      >
                        {item.tahun}
                      </DropdownItem>
                    ))}
                </DropdownMenu>
              </UncontrolledButtonDropdown>
              {currentUser?.peran == "super admin" && (
                <div className="d-flex align-items-center ml-3">
                  <Label for="filter-dinas-users" className="mb-0 mr-2">
                    Filter Dinas:
                  </Label>
                  <Input
                    id="filter-dinas-users"
                    type="select"
                    value={selectedDinasFilter}
                    onChange={(e) => setSelectedDinasFilter(e.target.value)}
                    style={{ minWidth: "180px" }}
                  >
                    <option value="All">All</option>
                    {listDinas.map((item, index) => (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    ))}
                  </Input>
                  <UncontrolledTooltip placement="top" target="filter-dinas-users">
                    Filter bantuan berdasarkan dinas/instansi. Pilih All untuk menampilkan semua.
                  </UncontrolledTooltip>
                </div>
              )}
            </div>
            <Button
              id="btn-tambah-bantuan-users"
              color="success"
              onClick={() => dispatchKu(push(`/admin/bantuan/new`))}
            >
              <i className="fa fa-plus mr-2" aria-hidden="true" />
              Tambah Bantuan
            </Button>
            <UncontrolledTooltip placement="left" target="btn-tambah-bantuan-users">
              Klik untuk menambah data bantuan baru
            </UncontrolledTooltip>
          </Col>
        </Row>

        <ToolkitProvider columns={columns} data={rowsKu} keyField="id" search>
          {(props) => (
            <div className={s.jenisBantuanTableWrap}>
              <BootstrapTable
                bordered={false}
                classes="table-striped table-hover mt-4"
                pagination={paginationFactory()}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </Widget>
      <Modal size="sm" isOpen={modalDelete} toggle={() => closeModal()}>
        <ModalHeader toggle={() => closeModal()}>Konfirmasi hapus</ModalHeader>
        <ModalBody>
          apakah anda yakin akan menghapus data bantuan ini?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => handleDelete()}>
            Delete
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

function mapStateToProps(store) {
  return {
    loading: store.users.list.loading,
    rows: store.users.list.rows,
    modalOpen: store.users.list.modalOpen,
    idToDelete: store.users.list.idToDelete,
  };
}

export default connect(mapStateToProps)(UsersListTable);
